<ng-container *ngFor="let seccion of estructuraNoticias; let i = index" class="row">
  {{ iniciarContador(0) }}
  {{ iniciarContadorBloques(0) }}
  <img class="img-separador" [src]="seccion?.urlImagenSeparador" alt="imagen separador" loading="lazy" />
  <ng-container *ngFor="let bloque of seccion?.bloques; let j = index" class="row" [ngSwitch]="bloque.tipo_bloque">
    <div class="row" [ngClass]="[getExtraClass(bloque.bloque), countUnaColumna ? 'position-relative' : '']" *ngSwitchCase="'fila-una-columna'">
      <app-fila-una-columna [noticias]="getNoticiasSeccion(seccion.id_seccion)" [idStart]="countNoticias"></app-fila-una-columna><br />
      {{ incrementarContadorUnaColumna() }}
      {{ incrementarContador(bloque.num_elementos) }}
    </div>
    <div class="row" [ngClass]="getExtraClass(bloque.tipo_bloque)" *ngSwitchCase="'fila-dos-columnas'">
      <app-fila-dos-columnas [noticias]="getNoticiasSeccion(seccion.id_seccion)" [idStart]="countNoticias"></app-fila-dos-columnas><br />
      {{ incrementarContador(bloque.num_elementos) }}
    </div>
    <div class="row" [ngClass]="getExtraClass(bloque.tipo_bloque)" *ngSwitchCase="'fila-tres-columnas'">
      <app-fila-tres-columnas [noticias]="getNoticiasSeccion(seccion.id_seccion)" [idStart]="countNoticias"></app-fila-tres-columnas><br />
      {{ incrementarContador(bloque.num_elementos) }}
    </div>
    <div class="row" [ngClass]="getExtraClass(bloque.tipo_bloque)" *ngSwitchCase="'fila-cuatro-columnas'">
      <app-fila-cuatro-columnas [noticias]="getNoticiasSeccion(seccion.id_seccion)" [idStart]="countNoticias"></app-fila-cuatro-columnas>
      {{ incrementarContador(bloque.num_elementos) }}
    </div>
    <div class="row" [ngClass]="getExtraClass(bloque.tipo_bloque)" *ngSwitchCase="'dos-columnas-multifilas'">
      <app-dos-columnas-multifilas [noticias]="getNoticiasSeccion(seccion.id_seccion)" [idStart]="countNoticias"></app-dos-columnas-multifilas>
      {{ incrementarContador(bloque.num_elementos) }}
    </div>
    <div class="row" [ngClass]="getExtraClass(bloque.bloque)" *ngSwitchCase="'bloque-ultimos-blogs'">
      <app-bloque-ultimos-blogs></app-bloque-ultimos-blogs>
    </div>
    <div class="row" [ngClass]="getExtraClass(bloque.bloque)" *ngSwitchCase="'bloque-patrocinados'">
      <app-bloque-patrocinados [idSeccion]="bloque.id_seccion"></app-bloque-patrocinados>
      {{ incrementarContador(bloque.num_elementos) }}
    </div>
    {{ incrementarContadorBloques() }}
  </ng-container>
</ng-container>
